import { useSelector } from 'react-redux';

export const useSearchAttempted = () => useSelector( state => {
    try{
        return state.slugInfo.components.searchAttempted;
    }catch(e){}
});

export default () => {
    return useSelector( state => {
        try{
            return state.slugInfo.components.hawksearchResults;
        }catch(e){}
    });
}